<template>
  <div id="app">
    <v-app id="inspire" light>
      <v-card color="grey lighten-2" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>AMADEUS Bilet Aktarımı</v-toolbar-title>
              <v-spacer></v-spacer>

              <!-- <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field> -->

              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-title>...</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>
          <v-container fluid>
            <v-card color="grey lighten-1" flat>
              <v-layout row wrap>



                <v-flex xs12 sm6 md2>
                  <v-layout align-center justify-start row fill-height>
                    <v-form ref="formaktarim" id="formaktarim" method="post" enctype="multipart/form-data" v-model="valid"
                      lazy-validation>
                      <input hidden type="file" id="file" ref="file" multiple v-on:change="handleFileUpload()" />
                    </v-form>
                    <v-btn :loading="false" :disabled="false" color="info" dark @click="addFiles()">
                      <v-icon color="white" left>attach_file</v-icon>Aktarım Dosyası Seçiniz
                    </v-btn>
                    <div v-show="load2">
                      <v-btn small="" fab @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="SubmitFile()"
                        color="info" dark>
                        <v-icon>redo</v-icon>
                      </v-btn>
                      <v-tooltip bottom="" :activator="el" v-model="tooltip">
                        <span>Seçilenleri Aktar</span>
                      </v-tooltip>
                    </div>
                    <!-- <div v-if="status.loading">
                      <v-layout>
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                      </v-layout>
                    </div> -->
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md4>
                </v-flex>
                <v-flex xs12 sm12 md6>
                  <v-alert :value="true" :color="alertcolor" icon="check_circle" outline>
                    {{alertmessage}}
                  </v-alert>
                </v-flex>

                <v-dialog v-model="load3" hide-overlay persistent width="400">
                  <v-card color="primary" dark>
                    <v-card-text>
                      Lütfen Bekleyiniz...
                      <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                  </v-card>
                </v-dialog>

              </v-layout>
            </v-card>
          </v-container>
          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs12 sm6 md6>

                <v-toolbar size="120px" dark color="info">
                  <v-toolbar-title>Aktarılan Biletler</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>
                </v-toolbar>
                <v-card>
                  <v-data-table :headers="headers" :rows-per-page-items=[20,50] :loading="progress" :items="itemsok"
                    :search="search3">
                    <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                    <template slot="items" slot-scope="props">
                      <tr item>
                        <td class="text-xs-left">{{ props.item.BiletNo }}</td>
                        <td class="text-xs-left">{{ props.item.Aciklama }}</td>
                        <v-btn icon class="mx-0" @click="git(props.item)">
                          <v-icon color="teal">search</v-icon>
                        </v-btn>
                      </tr>
                    </template>
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                      Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                    </v-alert>
                  </v-data-table>
                </v-card>

              </v-flex>
              <v-flex xs12 sm6 md6>




                <v-toolbar size="120px" dark color="red">
                  <v-toolbar-title>Aktarılamayan Biletler</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-text-field flat="" solo-inverted="" hide-details v-model="search4" label=" Ara" append-icon="search"></v-text-field>
                </v-toolbar>

                <v-card>

                  <v-data-table :headers="headers" :rows-per-page-items=[20,500] :loading="progress" :items="itemsno"
                    :search="search4">
                    <v-progress-linear slot="progress" indeterminate></v-progress-linear>

                    <template slot="items" slot-scope="props">
                      <tr item>
                        <td class="text-xs-left">{{ props.item.BiletNo }}</td>
                        <td class="text-xs-left">{{ props.item.Aciklama }}</td>

                      </tr>
                    </template>
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                      Aradığınız "{{ search4 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                    </v-alert>
                  </v-data-table>
                </v-card>














              </v-flex>
              <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
                :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                {{ text1 }}
                <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
              </v-snackbar>
            </v-layout>
          </v-container>



        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../../api/auth'
  import Vue from 'vue'
  import axios from 'axios'

  export default {
    data() {
      return {
        search: '',
        headers: [{
            text: 'Bilet No',
            value: 'BiletNo'
          },
          {
            text: 'Durum',
            value: 'Aciklama'
          }

        ],


        itemsok: [],
        itemsno: [],


        valid: true,
        searchcari: '',
        dictionary: {
          custom: {
            masrafkodu: {
              required: () => 'Lütfen seçiminizi yapınız'
            },
            tarihsec: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
            tarihsec1: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
          }
        },

        dialogfiltre: false,

        search4: null,
        file: [],
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        load3: false,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        loading: false,
        progress: false,
        items: [],
        load: false,
        alertcolor: "red",
        alertmessage: 'Henüz Dosya Seçilmedi...',

        load1: true,
        load2: false,
        search3: '',
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        tooltip: false,
        el: null,
      }
    },
    beforeMount: beforeMount,
    watch: {
      searchcari(val) {
        val && this.carigetir(val)
      }
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el
    },
    methods: {
      addFiles() {
        this.$refs.file.click();
      },
      handleFileUpload() {
        this.file = []
        var uploadedFiles = this.$refs.file.files;

        if (uploadedFiles.length > 0) {
          this.load2 = true
          this.load = true
            this.alertcolor = "success";
          this.alertmessage = "Toplam " + uploadedFiles.length + " adet dosya seçildi."
          for (var i = 0; i < uploadedFiles.length; i++) {
            this.file.push(uploadedFiles[i]);
          }

        } else {
          this.alertmessage = "Henüz Dosya Seçilmedi...";
          this.alertcolor = "red";
          this.load = false
          this.load2 = false
        }
      },
      SubmitFile() {
        this.load3= true;
        this.itemsno = [];
        this.itemsok = [];
        var cred = JSON.parse(window.localStorage.getItem('credentials'));
        let formData = new FormData();
        for (var i = 0; i < this.file.length; i++) {
          let file = this.file[i];
          formData.append('file[' + i + ']', file);
        }
        formData.append('CustomerCode', cred.AnaSirketKodu)
        formData.append('TransferType', '0')
        axios.defaults.baseURL = auth.API_URL;
        axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';


        axios.post(auth.API_URL + 'api/TicketDefinitons/FileUpload',
            formData, {
              headers: {
                Authorization: `Bearer ${auth.getAuthHeader()}`
              }
            }
          ).then((response) => {

            if (response.data == true) {

              this.load2 = true
              this.load = false

              var credentials = JSON.parse(window.localStorage.getItem('credentials'));

              var params1 = {
                CompanyCode: credentials.SirketKodu,
                CustomerCode: credentials.AnaSirketKodu
              }

              this.$http.post(auth.API_URL + 'api/TicketStream/AmadeusStream', params1, {
                headers: {
                  'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
              }).then((response) => {

                this.itemsok = []
                this.itemsno = []

                response.body.forEach(element => {
                  if (element.Status == true) {
                    this.itemsok.push(element)
                  } else {
                    this.itemsno.push(element)
                  }
                });

                this.text1 = "toplam " + this.itemsok.length + " adet bilet aktarımı tamamlandı"
                this.snackbar = true
                this.load = true
                this.load1 = true
                this.load2 = false
                this.load3 = false;


              }, (response) => {
                if (response.status === 0) {
                  this.text1 = 'Service Unavailable'
                  this.snackbar = true
                  this.load1 = true
                  this.load2 = false
                  this.load = true
                  this.load3 = false;

                } else {
                  this.text1 = 'Service Unavailable'
                  this.snackbar = true
                  this.load1 = true
                  this.load = true
                  this.load3 = false;


                  this.load2 = false
                }
              })
            } else {
              this.text1 = "Dosya aktarımı yapılamadı lütfen tekrar deneyin"
              this.snackbar = true
            }
          })
          .catch(function () {
            console.log('hata!!');
          });
      },
      formatDate(date) {
        var str = date
        var n = str.search('.')
        if (n == 1) {
          return null
        } else {
          const [year, month, day] = date.split('-')
          return `${day}.${month}.${year}`
        }
      },
      parseDate(date) {
        if (!date) return null
        var str = date
        var n = str.search('-')
        var m = str.length
        if (n == 1) {
          const [month, day, year] = date.split('-')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        } else if (m == 8) {
          console.log('')
        } else if (n == -1 && m != 8) {
          this.dateFormatted = getDateNow1()
          this.date = getDateNow()
        } else {
          const [day, month, year] = date.split('.')
          return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        }
      },

      onChange: onChange,
      getDateNow1: getDateNow1,
      getDateNow: getDateNow,
      git: git
    }
  }


  function git(v) {


    var url = '#/bilet/yeni/id?' + 'isl=get&hyolukod=' + v.HavayoluKodu + '&biletno=' + v.BiletNo + '&ucustipi=' + v.UcusTipi
    window.open(url, '_blank')
  }





  function beforeMount() {
    this.dateFormatted = getDateNow1()
    this.date = getDateNow()
  }



  function onChange(v) {
    var c = v.length
    var a = v
    if (c == 8) {
      var b = a[4] + a[5] + a[6] + a[7] + '-' + a[2] + a[3] + '-' + a[0] + a[1]
      var ay = a[2] + a[3]
      var gun = a[0] + a[1]
      var yil = a[4] + a[5] + a[6] + a[7]

      a = new Date(b)

      if (a instanceof Date && !isNaN(a.valueOf())) {
        //şubatın 29 çekmesin
        if (ay == '02' && yil % 10 != 0 && gun == '29') {

          b = yil + '-' + ay + '-' + '28'
          this.date = b
          this.dateFormatted = '28' + '-' + ay + '-' + yil
          //31 nisan
        } else if (ay == '04' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date = b
          this.dateFormatted = '30' + '-' + ay + '-' + yil
          //31 haziran
        } else if (ay == '06' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date = b
          this.dateFormatted = '30' + '-' + ay + '-' + yil
          //31 eylül
        } else if (ay == '09' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date = b
          this.dateFormatted = '30' + '-' + ay + '-' + yil
          //31 kasım
        } else if (ay == '11' && gun == '31') {

          b = yil + '-' + ay + '-' + '30'
          this.date = b
          this.dateFormatted = '30' + '-' + ay + '-' + yil

        } else {
          this.date = b
        }
      } else {
        this.dateFormatted = null

      }
    } else {
      this.dateFormatted = null
    }
  }



  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }

  function getDateNow1() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = dd + '.' + mm + '.' + yyyy
    return today
  }
</script>
<style>
  .image-upload>input {
    display: none;
  }

  .image-upload img {
    width: 80px;
    cursor: pointer;
  }
</style>